import { correctVariableType } from './correctVariableType.js';

export function getURLParameter(key) {
  if (typeof URLSearchParams !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    return params.get(key) ? correctVariableType(params.get(key)) : undefined;
  }
  const vars = {};
  window.location.href
    .replace('#', '')
    .replace('!', '')
    .replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      (m, key, value) => {
        vars[key] = value;
      }
    );
  return vars[key] ? correctVariableType(vars[key]) : undefined;
}